import * as React from 'react';
import { createPortal } from 'react-dom';
import { useLayoutEffect } from '../../../hooks/useLayoutEffect';
import LayersContext from './LayersContext';
function Layer({
  host: hostProp = 'overlays',
  container = true,
  children
}) {
  const containerRef = React.useRef(null);
  const context = React.useContext(LayersContext);
  const host = context?.[hostProp] || globalThis.document?.body || null;
  function getContainer() {
    if (!container) return host;
    if (containerRef.current === null) {
      containerRef.current = host.ownerDocument.createElement('div');
    }
    return containerRef.current;
  }
  useLayoutEffect(() => {
    if (containerRef.current) {
      host.appendChild(containerRef.current);
    }
    return () => {
      if (containerRef.current) {
        host.removeChild(containerRef.current);
      }
    };
  }, [host]);
  if (!globalThis.document) {
    return null;
  }
  return /*#__PURE__*/createPortal(children, getContainer());
}
export default Layer;